import {AxiosResponse} from 'axios';
//api
import {orgAPI, userAPI} from '@/core/api';
//types
import {
	IOrganizationAttendeesStatistics,
	IOrganizationAttendeesListRequest,
	IOrganizationAttendeesListResponse,
	IOrganizationAttendee,
	IOrganizationUpdateAttendeeRequest,
	IOrganizationAttendeeBidsResponse,
	IOrganizationAttendeeBidsRequest,
	INotificationPreferences,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';
import {PAYMENT_METHOD} from '../enums';

class OrganizationAttendeesService {
	static getAttendeesList = async (
		reqBody: IOrganizationAttendeesListRequest
	): Promise<AxiosResponse<IOrganizationAttendeesListResponse>> => orgAPI.post(API_URL.ATTENDEE, reqBody);

	static getAttendee = async (attendeeId: number): Promise<AxiosResponse<IOrganizationAttendee>> =>
		orgAPI.get(`${API_URL.ATTENDEE}/${attendeeId}`);

	static updateAttendee = async (
		attendeeId: number,
		reqBody: IOrganizationUpdateAttendeeRequest
	): Promise<AxiosResponse<IOrganizationAttendee>> => orgAPI.put(`${API_URL.ATTENDEE}/${attendeeId}`, reqBody);

	static getAttendeeBids = async (
		reqBody: IOrganizationAttendeeBidsRequest
	): Promise<AxiosResponse<IOrganizationAttendeeBidsResponse>> => orgAPI.post(API_URL.BIDS_FOR_BIDDER, reqBody);

	static getAttendeesStatistics = async (eventId: number): Promise<AxiosResponse<IOrganizationAttendeesStatistics>> =>
		orgAPI.get(`${API_URL.ATTENDEE_STATISTICS}/${eventId}`);

	static updateAttendeesVip = async (attendeeId: number, isVip: boolean): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.ATTENDEE_VIP}/${attendeeId}`, {isVip});

	static updateAttendeesStatus = async (attendeeId: number, attendeeStatus: string): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.ATTENDEE_STATUS}/${attendeeId}?attendeeStatus=${attendeeStatus}`);

	static updateAttendeeAccountStatus = async (attendeeId: number, isLocked: boolean): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.ATTENDEE_ACCOUNT}/${attendeeId}`, {isLocked});

	static deleteAttendee = async (attendeeId: number): Promise<AxiosResponse> =>
		orgAPI.delete(`${API_URL.ATTENDEE}/${attendeeId}`);

	static deleteAttendeeData = async (attendeeId: number): Promise<AxiosResponse> =>
		orgAPI.delete(`${API_URL.ATTENDEE}/${attendeeId}/soft`);

	static updateAttendeeFromContactList = async (
		eventId: number,
		columnName: string,
		reqBody: IOrganizationUpdateAttendeeRequest[]
	): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.UPDATE_ATTENDEE_FROM_CONTACT_LIST}/${eventId}?columnName=${columnName}`, reqBody);

	static getAttendeeDuplicates = async (attendeeId: number, columnName: string): Promise<AxiosResponse> =>
		orgAPI.get(`${API_URL.ATTENDEE_DUPLICATES}/${attendeeId}?columnName=${columnName}`);

	static addAttendeePaymentStatus = async (attendeeId: number, paymentMethod: PAYMENT_METHOD): Promise<AxiosResponse> =>
		userAPI.put(`${API_URL.ATTENDEE}/${attendeeId}/payment-method`, {paymentMethod});

	static updateAttendeeNotificationPreferences = async (attendeeId: number, data: INotificationPreferences): Promise<AxiosResponse> =>
		orgAPI.put(`${API_URL.ATTENDEE}/${attendeeId}/notification-preferences`, data);
}

export {OrganizationAttendeesService};
